/* eslint-disable */

import { Formik, Form, Field } from "formik";
import { useState } from "react";
import { Modal } from "antd";
import { Helmet } from "react-helmet";
import PhoneInput from "react-phone-input-2";
import Select from "react-select";

import CustomDropdown from "../../components/CustomDropdown/CustomDropdown";

import * as Yup from "yup";

import SecondaryHeader from "../../components/SecondaryHeader/SecondaryHeader";
import Footer from "../../components/Footer/Footer";
import Button from "../../components/Button/Button";
import Verified from "../../assets/icons/Verified";
import { useNavigate } from "react-router";

import WrongIcon from "../../assets/icons/WrongIcon";
import CheckIcon from "../../assets/icons/CheckIcon";
import { subjects } from "../../data";

const ForParents = () => {
  const navigate = useNavigate();
  const emailReg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

  const [confirmVisible, setConfirmVisible] = useState(false);

  const initialValues = {
    firstName: "",
    lastName: "",
    role: "",
    schoolName: "",
    schoolAddress: "",
    email: "",
    phone: "",
  };

  const handleCancel = () => {
    setConfirmVisible(false);
  };

  return (
    <div>
      <Helmet>
        <title>PL by Edves | For Parents</title>
      </Helmet>
      <SecondaryHeader />

      <div className="login">
        <div className="login__heading">
          <h2>We will personalize your child’s learning experience</h2>
          <p>Enter your details correctly to join our waitlist</p>
        </div>

        <div className="login__form" style={{ marginBottom: "62px" }}>
          <div className="auth-wrapper__right__form">
            <Formik
              initialValues={initialValues}
              validationSchema={Yup.object({
                firstName: Yup.string()
                  .required("Field cannot be empty")
                  .min(2),
                lastName: Yup.string().required("Field cannot be empty").min(2),
                phone: Yup.string().required("Field cannot be empty"),
                securityQuestion: Yup.string().required(
                  "Field cannot be empty"
                ),
                email: Yup.string()
                  .required("Field cannot be empty")
                  .matches(emailReg, "Invalid Email"),
                schoolOfInterest: Yup.string()
                  .required("Field cannot be empty")
                  .min(2),
                answer: Yup.string().required("Field cannot be empty"),
              })}
              onSubmit={async (values, { setSubmitting }) => {
                setSubmitting(false);

                const data = { ...values };
                console.log(data);
              }}
            >
              {({
                isValid,
                dirty,
                isSubmitting,
                setFieldValue,
                errors,
                touched,
              }) => (
                <Form>
                  <div className="flex-to-column">
                    <div
                      className="auth-wrapper__right__form__inputwrapper eye-position"
                      style={{ width: "100%" }}
                    >
                      <label htmlFor="firstName">First name</label>

                      <Field
                        type="text"
                        name="firstName"
                        id="firstName"
                        placeholder="Enter your first name"
                        className={errors.firstName ? "input-error" : ""}
                      />
                      <div className="eye-icon">
                        {touched.firstName ? (
                          errors.firstName ? (
                            <WrongIcon />
                          ) : (
                            <CheckIcon />
                          )
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    <div
                      className="auth-wrapper__right__form__inputwrapper eye-position"
                      style={{ width: "100%" }}
                    >
                      <label htmlFor="lastName">Last name</label>

                      <Field
                        type="text"
                        name="lastName"
                        id="lastName"
                        placeholder="Enter your last name"
                        className={errors.lastName ? "input-error" : ""}
                      />

                      <div className="eye-icon">
                        {touched.lastName ? (
                          errors.lastName ? (
                            <WrongIcon />
                          ) : (
                            <CheckIcon />
                          )
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="auth-wrapper__right__form__inputwrapper eye-position">
                    <label htmlFor="email">Email Address</label>

                    <Field
                      type="email"
                      name="email"
                      id="email"
                      placeholder="Enter school address"
                      className={errors.email ? "input-error" : ""}
                    />
                    <div className="eye-icon">
                      {touched.email ? (
                        errors.email ? (
                          <WrongIcon />
                        ) : (
                          <CheckIcon />
                        )
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  <div className="auth-wrapper__right__form__inputwrapper">
                    <label htmlFor="email">Phone Number</label>

                    <PhoneInput
                      country={"ng"}
                      name="phone"
                      // onChange={(val) => setFieldValue("phone", val)}
                      onChange={(value) => {
                        setFieldValue("phone", value);
                      }}
                    />
                  </div>

                  <div className="auth-wrapper__right__form__inputwrapper eye-position">
                    <label htmlFor="schoolAddress">School of interest</label>

                    <Field
                      type="text"
                      name="schoolOfInterest"
                      id="schoolOfInterest"
                      placeholder="Which school (s) would you like to learn from?"
                      className={errors.schoolOfInterest ? "input-error" : ""}
                    />

                    <div className="eye-icon">
                      {touched.schoolOfInterest ? (
                        errors.schoolOfInterest ? (
                          <WrongIcon />
                        ) : (
                          <CheckIcon />
                        )
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  <div className="auth-wrapper__right__form__inputwrapper">
                    <label htmlFor="schoolAddress">Subject of interest</label>

                    <CustomDropdown />
                  </div>

                  <div className="auth-wrapper__right__form__inputwrapper">
                    <label htmlFor="schoolAddress">How old are you?</label>
                    <Select
                      options={subjects}
                      placeholder={"Select your age range"}
                    />
                  </div>

                  <div
                    className="auth-wrapper__right__form__inputwrapper"
                    style={{ marginBottom: "32px" }}
                  >
                    <label htmlFor="schoolAddress">
                      What class are you in?
                    </label>

                    <Field as="select" name="answer" id="answer">
                      <option value="">Select your class</option>
                      <option value="year-10">Year 10 (SSS 1)</option>
                      <option value="year-11">Year 11 (SSS 2)</option>
                      <option value="year-12">Year 12 (SSS 3)</option>
                    </Field>
                  </div>

                  <Button
                    text={"Notify Me When You Launch"}
                    className="primary-btn"
                    width="100%"
                    //  disabled={isSubmitting || !dirty || !isValid}
                    onClick={() => setConfirmVisible(true)}
                  />
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>

      <Footer />

      <Modal
        width={606}
        visible={confirmVisible}
        onOk={handleCancel}
        onCancel={handleCancel}
        footer={null}
      >
        <div style={{ padding: "40px" }}>
          <div className="modal-head" style={{ marginBottom: "32px" }}>
            <div className="confirm-icon-wrapper">
              <Verified />
            </div>
            <h2>Yayyy!</h2>
            <p>
              We have received your registeration, expect a mail from us soon on
              how to get started
            </p>
          </div>
          <Button
            text={"Go back home"}
            className="primary-btn"
            width="100%"
            onClick={() => {
              setConfirmVisible(false);
              navigate("/");
            }}
          />
        </div>
      </Modal>
    </div>
  );
};

export default ForParents;
